import { Box, Typography } from '@mui/material'

interface AppPageHeaderProps {
  title: string
  description: string
}

export const AppPageHeader = ({ title, description }: AppPageHeaderProps) => {
  return (
    <Box sx={{ mb: { xs: 3, md: 4 }, maxWidth: 760 }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description}
      </Typography>
    </Box>
  )
}
